module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', [(_vm.label !== '') ? _c('div', {
    staticStyle: {
      "display": "inline-block",
      "font-size": "1.4em",
      "margin": "0px 5px 10px 0px"
    }
  }, [_vm._v(_vm._s(_vm.label))]) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "btn __blue small-button",
    staticStyle: {
      "padding-top": "2px",
      "margin-bottom": "5px"
    },
    attrs: {
      "data-tooltip": _vm.$t("Help")
    },
    on: {
      "click": function($event) {
        return _vm.openLink(_vm.reflink)
      }
    }
  }, [_c('i', {
    staticClass: "ti-help"
  })])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-68f39fcc","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/HelpLink.vue
// module id = 385
// module chunks = 1